<template>
    <div class="customer-profile-details">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-2">
                <b-col lg="6" cols="12">
                    <router-link :to="'/customerProfile' + '?page=' + listing_current_page" class="text-primary">
                        <b-icon icon="chevron-left"></b-icon>
                        Customer Profile
                    </router-link>
                    <router-link v-if="previousRouteLink == '/loanAdvisoryListing'" :to="'/loanAdvisoryListing'" class="text-primary">
                        <b-icon icon="chevron-left"></b-icon>
                        Loan Advisory Listing
                    </router-link>
                </b-col>
            </b-row>
            <b-row v-if="current_customer">
                <b-col lg="6" cols="12">
                    <b-button-group class="btn-group-header mx-1 mt-md-2 my-lg-0" v-if="current_customer.hubManager">
                        <b-button size="sm" variant="light" class="btn-incharge" disabled>HM</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-if="current_customer.hubManager">{{current_customer.hubManager.name}}</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-else>-</b-button>
                    </b-button-group>
                    <b-button-group class="btn-group-header mx-1 mt-md-2 my-lg-0" v-if="current_customer.ssa">
                        <b-button size="sm" variant="light" class="btn-incharge" disabled>SSA</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-if="current_customer.ssa">{{current_customer.ssa.name}}</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-else>-</b-button>
                    </b-button-group>
                    <b-button-group class="btn-group-header mx-1 mt-md-2 mb-lg-2" v-if=" current_customer.sse">
                        <b-button size="sm" variant="light" class="btn-incharge" disabled>SSE</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-if="current_customer.sse">{{current_customer.sse.name}}</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-else>-</b-button>
                    </b-button-group>
                </b-col>
                <b-col lg="6" cols="12" class="text-right text-md-left text-lg-right">
										<b-button
                        class="btn-incharge font-weight-400 text-xs"
                        style="padding: 4px 5px; line-height: 14px"
                        :variant="onMonitoring ? 'danger':'light'" size="sm"
                        :loading="loading"
                        @click="setMonitoring"
                    >
                      {{ onMonitoring ? 'Monitoring ON':'Click for Monitoring' }}
                    </b-button>
                    <b-button
                        class="bg-primary font-weight-400 text-xs text-white"
                        style="padding: 4px 5px; line-height: 14px"
                        variant="primary" size="sm" v-if="!_gHlp.isFintosAdvisoryPoolCustomer(current_customer) && auth_user.account_info.is_use_advisory"
                        :loading="loading"
                        @click="sendToAdvisory"
                        
                    >
                        Send To FINTOS Advisory
                    </b-button>
                    <b-button 
                        class="btn-incharge font-weight-400 text-xs"
                        style="padding: 4px 5px; line-height: 14px"
                        variant="primary" size="sm"
                        
                        @click="toggleAssignModal"
                    >
                        Assign Advisor
                    </b-button>
                    
                    <button 
                        class="btn-incharge bg-success border-0 rounded text-xs px-2 py-1 text-white mx-1" 
                        disabled
                        v-if="_gHlp.isFintosAdvisoryPoolCustomer(current_customer)"
                    >
                        <template v-if="!_gHlp.isEmpty(current_customer.sent_to_fintos_advisory_at)">Sent to Advisory : {{ current_customer.sent_to_fintos_advisory_at | dateFormatString }}</template>
                        <template v-else>Sent to Advisory</template>
                    </button>

                    <b-button-group class="btn-group-header mx-1 mt-md-2 mb-lg-2">
                        <b-button size="sm" variant="light" class="btn-incharge" 
                        @click="toggleAssignModal"
                        disabled>SE</b-button>

                        <b-button class="btn-incharge text-dark" size="sm" variant="light" 
                        @click="toggleAssignModal"
                        disabled v-if="current_customer.se">{{current_customer.se.name}}</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-else>-</b-button>
                    </b-button-group>
                    
                    <b-button v-show="backButton" variant="primary" class="float-md-right float-lg-none ml-2 mt-2 mt-md-0 mb-md-0 mb-3" icon @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </b-button>
                </b-col>
            </b-row>
                
            
        </base-header>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col cols="12" lg="3">
                    <customer-biodata></customer-biodata>
                    <net-income></net-income>
                    <TotalJointCommitment v-if="current_customer && current_customer.cjp_id"/>
                    <total-instalment v-if="current_commitment && !current_customer.cjp_id" :commitments="current_commitment.credit_report_summary.commitments" :key="key.total_installment"></total-instalment>
                    <looking-for-product></looking-for-product>
                </b-col>
                <b-col cols="12" lg="9" v-if="current_customer">
                    <el-tabs
                        v-model="current_tab"
                        @tab-click="handleTabClick"
                    >
                        <el-tab-pane label="Overview" name="overview">
                            <b-row >
                                <b-col xl="8">
                                    <Overview @toggleAssignModal="toggleAssignModal" :customer="current_customer"/>
                                </b-col>
                                <b-col xl="4">
                                    <LoanEligibility />
                                    <div v-if="!current_customer.cjp_id">
                                        <SaaCard/>
                                        <LegalCases/>
                                        <Bankruptcy/>
                                        <TradeReferences/>
                                        <AkpkCard/>
                                    </div>
                                    <Remark :base_url="services.customer + 'customer/'+$route.params.customer_id+'/remarks'" type="customer"/>
                                </b-col>
                            </b-row>
                        </el-tab-pane>
                        <el-tab-pane label="Proposal" name="proposal" :lazy="true" :disabled="current_customer && current_customer.ssa == null" v-if=" _gHlp.checkAccess(['pr_proposal__listing'])">
                            <b-row>
                                <b-col md="8">
                                    <ProposalApplication/>
                                </b-col>
                                <b-col md="4">
                                    <ProposalActivityLog/>
                                </b-col>
                            </b-row>
                        </el-tab-pane>
                        <el-tab-pane label="Cases" name="cases" :lazy="true">
                            <b-row>
                                <b-col xl="8">
                                    <CaseList ref="case_list"/>
                                </b-col>
                                <b-col xl="4">
                                    <cases-log></cases-log>
                                </b-col>
                            </b-row>
                        </el-tab-pane>
                        <el-tab-pane label="Commitment" name="commitment" :lazy="true">
                            <div :key="key.commitment">
                                <b-row v-if="!current_customer.cjp_id">
                                    <b-col xl="8">
                                        <commitment v-if="current_commitment" :platform.sync="current_commitment.credit_report_platform" :commitment.sync="current_commitment.credit_report_summary"  :reportData.sync="current_commitment.report_data"></commitment>
                                        <div v-else>
                                            <b-card no-body>
                                                <div class="bg-light p-3 text-center rounded">
                                                    This customer did't purchase report yet
                                                </div>
                                            </b-card>
                                        </div>
                                    </b-col>
                                    <b-col xl="4" v-if="current_commitment">
                                        <fintscore-report></fintscore-report>
                                        <total-commitment :commitment="current_commitment.credit_report_summary.commitments"></total-commitment>
                                        <ccris-derivatives :ccris-derivatives="current_commitment.credit_report_summary.ccris_derivatives"></ccris-derivatives>
                                        <credit-info :credit-info="current_commitment.credit_report_summary.credit_info_of_glance"></credit-info>
                                    </b-col>
                                </b-row>
                                <div>
                                    <el-tabs
                                        @tab-click="tabChangeJointCommitment"
                                        v-model="tab_commitment_cust_id"
                                    >
                                        <el-tab-pane 
                                            :label="profile.name" 
                                            :name="profile.customer_id.toString()" 
                                            v-for="(profile, index) in current_customer.customer_joint_profiles"
                                            :key="index"
                                        >
                                        <b-row class="w-100">
                                            <b-col xl="8">
                                                <commitment v-if="current_commitment" :commitment.sync="current_commitment.credit_report_summary" :reportData.sync="current_commitment.report_data"></commitment>
                                                <div v-else>
                                                    <b-card no-body>
                                                        <div class="bg-light p-3 text-center rounded">
                                                            This customer did't purchase report yet
                                                        </div>
                                                    </b-card>
                                                </div>
                                            </b-col>
                                            <b-col xl="4" v-if="current_commitment">
                                                <fintscore-report></fintscore-report>
                                                <total-commitment :commitment="current_commitment.credit_report_summary.commitments"></total-commitment>
                                                <ccris-derivatives :ccris-derivatives="current_commitment.credit_report_summary.ccris_derivatives"></ccris-derivatives>
                                                <credit-info :credit-info="current_commitment.credit_report_summary.credit_info_of_glance"></credit-info>
                                            </b-col>
                                        </b-row>
                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>
                        </el-tab-pane>
                        <!-- <el-tab-pane label="Documents" name="documents" :lazy="true"  v-if="auth_user.subscription.privileges.scpk_cus_document_upload"> -->
                        <el-tab-pane label="Documents" name="documents" :lazy="true"  v-if="checkAccess(['c_customer_attachment__listing']) || auth_user.subscription.privileges.scpk_cus_document_upload">
                            <b-row>
                                <b-col cols="12">
                                    <documents
                                        :base_url="services.customer + 'customer/' + $route.params.customer_id +'/attachments'"
                                        :retrieve_url="services.customer + 'customer/' + $route.params.customer_id +'/attachments.all'"
                                    ></documents>
                                </b-col>
                            </b-row>
                        </el-tab-pane>
                    </el-tabs>
                </b-col>
            </b-row>
        </b-container>

        <!-- Modal Assign Agent -->
        <modal :show.sync="modals.assign_agent">
            <h6 slot="header" class="modal-title">Please assign the customer to:</h6>
            <b-row>
                 <b-col cols="12" v-if="fTM">
                    <b-form-group label="TM:">
                        <el-select v-model="selected_se_id" placeholder="Select" filterable :disabled="this.corporate.includes('iMoney')">
                            <el-option selected value=""></el-option>
                            <el-option disabled v-if="selected_se_id !== ''" style="display: none" :label="current_customer && current_customer.se ? current_customer.se.name : ''" :value="current_customer && current_customer.se ? current_customer.se.id: ''"></el-option>
                            <el-option
                            v-for="item in userSeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col cols="12" v-if="fAdvisor">
                    <b-form-group label="Advisor:">
                        <el-select v-model="selected_ssa_id" placeholder="Select" filterable>
                            <el-option selected value=""></el-option>
                            <el-option
                            v-for="item in agentsList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col cols="12" v-if="fSupport">
                    <b-form-group label="Support:">
                        <el-select v-model="selected_sse_id" placeholder="Select" filterable>
                            <el-option selected value=""></el-option>
                            <el-option
                            v-for="item in userSseList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <!-- <b-col cols="12" v-if="_gHlp.checkRoleType( ['admin', 'manager', 'director', 'corporate']) || _gHlp.checkAccess(['role_ssa','role_hub_manager'])">
                    <b-form-group label="Sales Executive">
                        <el-select v-model="selected_se_id" placeholder="Select" filterable>
                            <el-option selected value=""></el-option>
                            <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col> -->

            </b-row>
            <div slot="footer">
                <el-button class="bg-primary text-white" @click="assignAgent" :loading="loading">Update</el-button>
            </div>
        </modal>
        <LoadingPage :is_loading="is_loading_page"/>
    </div>
</template>
<script>
    import useCustomerAssignmentStore from "@/stores/customerAssignmentStore";
    import { Tabs, TabPane, Alert, Button, Dropdown, DropdownMenu, DropdownItem, Link, Option, Select } from 'element-ui'
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
    import CustomerBiodata from '@/views/CustomerProfile/CustomerProfileDetails/LeftProfileDetails/CustomerBiodata'
    import NetIncome from '@/views/CustomerProfile/CustomerProfileDetails/LeftProfileDetails/NetIncome'
    import LookingForProduct from '@/views/CustomerProfile/CustomerProfileDetails/LeftProfileDetails/LookingForProduct'
    import TotalJointCommitment from '@/views/CustomerProfile/CustomerProfileDetails/LeftProfileDetails/TotalJointCommitment'
    import TotalInstalment from '@/views/CustomerProfile/CustomerProfileDetails/LeftProfileDetails/TotalInstalment'
    import LoanEligibility from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/LoanEligibility'
    import SaaCard from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/SaaCard'
    import LegalCases from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/LegalCases'
    import Bankruptcy from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/Bankruptcy'
    import TradeReferences from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/TradeReferences'
    import AkpkCard from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/AkpkCard'
    import Remark from '@/components/Remark'
    import Overview from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/Overview'
    import ProposalApplication from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/ProposalCards/ProposalApplication'
    import Documents from '@/components/Documents'
    import Commitment from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/Commitment'
    import FintscoreReport from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/CommitmentCards/FintscoreReport'
    import TotalCommitment from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/CommitmentCards/TotalCommitment'
    import CcrisDerivatives from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/CommitmentCards/CcrisDerivatives'
    import CreditInfo from '@/views/CustomerProfile/CustomerProfileDetails/RightProfileDetails/CommitmentCards/CreditInfo'
    import CaseList from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/CaseList'
    import CasesLog from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/CasesLog'
    import ProposalActivityLog from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/ProposalCards/ProposalActivityLog'
    import { mapActions, mapState } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useFintscoreStore } from '@/stores/fintscoreStore'
    import { useProductStore } from '@/stores/productStore'
    import { useAuthStore } from '@/stores/authStore'
    import { useMessagingStore } from '@/stores/messagingStore'
    import { useNotificationStore } from '@/stores/notificationStore'
    import { useAccessControlStore } from '@/stores/accessControlStore'
    import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader
    } from '@/assets/js/httpImports.js'
    import { CAN_ASSIGN_ROLE_IDS } from '@/assets/js/roles.js' 
    import LoadingPage from '@/components/LoadingPage'
    import _ from 'lodash'
    import { APP_MODE } from '@/assets/js/config';


    export default {
        components: {
            TotalJointCommitment,
            LoadingPage,
            CustomerBiodata,
            NetIncome,
            LookingForProduct,
            TotalInstalment,
            LoanEligibility,
            SaaCard,
            LegalCases,
            Bankruptcy,
            AkpkCard,
            TradeReferences,
            Remark,
            Overview,
            ProposalApplication,
            Documents,
            Commitment,
            FintscoreReport,
            TotalCommitment,
            CcrisDerivatives,
            CreditInfo,
            CaseList,
            CasesLog,
            ProposalActivityLog,
            // RouteBreadCrumb,
            [Link.name]: Link,
            [Tabs.name]: Tabs,
            [Alert.name]: Alert,
            [TabPane.name]: TabPane,
            [Button.name]: Button,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        computed: {
            ...mapState(useCustomerStore,['current_commitment', 'current_customer', 'listing_current_page']),
            ...mapState(useAuthStore,['auth_user']),
            ...mapState(useAccessControlStore,['userSsaList', 'userSseList', 'userList', 'userSeList', 'userHeadList', 'userProcessorList']),
            ...mapState(useCustomerAssignmentStore, ["fTM", "fAdvisor", "fSupport"]),
            // ...mapState(useAccessControlStore,['userSsaList','userSseList','userSeList', 'userHubManagerList', 'userList']),

            // salesAdvisors() {
            //     const targetRoleNames = ["Mobile Sales Advisor", "SSA", "Manager", "Sales Director"];
            //     const excludedRoleNames = ["Sales Support Manager"];

            //     // return this.agents.filter((agent) =>
            //     //     agent.roles.some((role) => 
            //     //         targetRoleNames.some((targetRoleName) =>  
            //     //             role.role_name.includes(targetRoleName) && !role.role_name.includes(excludedRoleNames)
            //     //         )
            //     //     )
            //     // );
            //     return this.agents
            // },
            // salesSupportExecutives() {
            //     return this.agents.filter((agent) =>
            //         agent.roles.some((role) =>
            //             role.role_name == "SSE" || 
            //             role.role_name == "Sales Support Manager" 
            //         )
            //     );
            // },
            // salesExecutives() {
            //     return this.agents.filter((agent) =>
            //         agent.roles.some(
            //         (role) =>
            //             role.role_name == "Sales Executive" ||
            //             role.role_name.includes("MSP") 
            //         )
            //     );
            // },
						onMonitoring(){
							return this.current_customer.user_settings?.is_monitoring ? true : false;
						},
						userSsaUnderHubManager(){
							if(this.isEmpty(this.selected_se_id)) return this.userSsaList;
							
							let selected_se_id = this.selected_se_id;
							let selected_ssa_id = this.selected_ssa_id;
							let result = _.filter(this.userSsaList,(o)=>{
								return (((o.parent_se_ids).indexOf(selected_se_id) != -1) || (o.id == selected_ssa_id));
							});
							return result;
						}
        },
        beforeRouteEnter(to, from, next) {
            // Use a callback function to access the component instance
            next(vm => {
            // Access the previous route link using the component instance
            vm.previousRouteLink = from.path;
            });
        },
        data() {
            return {
                is_loading_page: false,
                backButton: true,
                selected_ssa_id: '',
                selected_sse_id: '',
                selected_se_id: '',
                 corporate: '',
                agents: [],
                modals: {
                    assign_agent: false,
                },
                current_tab: 'overview',
                services: services,
                loading:false,
                key:{
                    total_installment: 1,
                    commitment: 1
                },
                previousRouteLink: null,
                CAN_ASSIGN_ROLE_IDS: CAN_ASSIGN_ROLE_IDS,
                is_sta_disabled: false,
                current_joint_commitment: null,
                joint_commitments:[],
                tab_commitment_cust_id: null,
            };
        },
        watch: {
            '$route.query.active': {
                handler(newValue, oldValue) {
                    this.current_tab = newValue 
                },
                immediate: true
            },
            current_commitment(newVal){
                if(newVal){
                    this.key.total_installment = this.key.total_installment + 1
                    this.key.commitment = this.key.commitment + 1
                }
            },
            corporate(newVal) {
                // if (newVal === 'iMoney') {
                //     this.selected_se_id = null
                // }
            }
        },
        async created() {
            this.agentsList = await this.getUserList()
            
            this.is_loading_page = true
            this.resetProductStore()
            if (this.$route.params.token) {
                this.backButton = true;
            }
            this.$watch(
            'current_customer',
            (newVal, oldVal) => {
                if (newVal) {
                    this.selected_ssa_id = newVal.ssa ? newVal.ssa.id : ''
                    this.selected_sse_id = newVal.sse ? newVal.sse.id : ''
                    this.selected_se_id = newVal.se ? newVal.se.id : ''
                    this.corporate = newVal.corporate ? newVal.corporate : ''
                    // check if joint customer
                    if(newVal.cjp_id){
                        this.getJointCustomerCommitments()
                    }else{
                        this.getCommitment()
                    }
                    this.getEligibility()
                    this.getAllFintscoreReport(newVal.customer_id)
                }
            },
            { immediate: true }
            );
            // this.agents = await this.getUserList()
            
            //check active tabs
            if(this.$route.query.active){
                this.current_tab = this.$route.query.active.toLowerCase() 
            }else{
                const query = { ...this.$route.query, active: 'overview' };
                this.$router.push({path: this.$route.path, query});
            }
            this.is_loading_page = false
        },
        methods: {
            ...mapActions(useProductStore, ['resetProductStore']),
            ...mapActions(useFintscoreStore, ['getAllFintscoreReport','resetFintscoreStore']),
            ...mapActions(useMessagingStore, ['sendEmail','getProfileBundleKey','checkUserGroup']),
            ...mapActions(useNotificationStore, ['fetchEmailTemplate']),
            ...mapActions(useCustomerStore,['getCommitment', 'resetCustomerStore', 'getCustomer', 'getEligibility']),
            ...mapActions(useAccessControlStore,['getUser']),
             ...mapActions(useCustomerAssignmentStore, ["setFTM", "setFAdvisor", "setFSupport"]),
            tabChangeJointCommitment(tab){
                this.tab_commitment_cust_id= tab.name
                let commitment = this.joint_commitments.find((item) => item.credit_report_cust_id == this.tab_commitment_cust_id)
                if(commitment){
                    useCustomerStore().$patch({
                        current_commitment: commitment
                    })
                }else{
                    useCustomerStore().$patch({
                        current_commitment: null
                    })
                }
            },
            getJointCustomerCommitments(){
                this.tab_commitment_cust_id = this.current_customer.customer_joint_profiles[0].customer_id.toString()
                this.current_customer.customer_joint_profiles.forEach((profile) => {
                    axios.get(services.commitment +'credit-report/summary', {
                        params: {credit_report_cust_id: profile.customer_id},
                        headers: getHeader()
                    })
                    .then(res=>{
                        this.joint_commitments.push(res.data)
                        let commitment = this.joint_commitments.find((item) => item.credit_report_cust_id == this.tab_commitment_cust_id)
                        if(commitment){
                            useCustomerStore().$patch({
                                current_commitment: commitment
                            })
                        }else{
                            useCustomerStore().$patch({
                                current_commitment: null
                            })
                        }
                    })
                });
            },
            handleTabClick(obj, e){
                if(this.$route.query.active !== obj.name){
                    const query = { ...this.$route.query, active: obj.name };
                    this.$router.push({path: this.$route.path, query});
                }
                if(obj.name === 'cases' && !_gHlp.isEmpty(this.$refs.case_list)){
                    this.$refs.case_list.getCases()
                }
            },
            // Method to send an email with LOAN_ADVISORY trigger point
           async sendLoanAdvisoryEmail(customerId) {
              try {
                  const emailTemplate = await this.fetchEmailTemplate('LOAN_ADVISORY');
                  if (emailTemplate && emailTemplate.is_active) {
                
                    const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                    const incomeTypeName = await this.getIncomeTypeName(this.current_customer.incomes.main.income_type_id);
          
                    let baseUrl = window.location.origin;
                    
                    // Construct the full customer profile link
                    const customerProfileLink = `${baseUrl}/customerProfileDetails/${customerId}?active=overview`;
                    const customerProfileLinkHtml = `<a href="${customerProfileLink}">${customerProfileLink}</a>`;

                    // Prepare the HTML body for the email
                    const htmlBody = emailTemplate.notif_temp_message
                    .replace('{corporate}', this.current_customer.corporate ?? 'N/A')
                    // .replace('{tat}', this.current_customer.status?.tat_summary?.remain_day ?? 'N/A')
                    .replace('{customer_name}', this.current_customer.name ?? 'N/A')
                    .replace('{customer_id}', customerId ?? 'N/A')
                    .replace('{channel}', this.current_customer.channel?.name ?? 'N/A')
                    .replace('{created_by}', this.current_customer.created_by_detail?.name ?? 'N/A')
                    .replace('{net_income}', this.current_customer.incomes?.main?.net_income ?? 'N/A')
                    .replace('{income_type}', incomeTypeName ?? 'N/A')
                    .replace('{age}', this.current_customer.age ?? 'N/A')
                    .replace('{customer_link}', customerProfileLinkHtml ?? 'N/A'); // Insert clickable HTML link
                    // Prepare the email data
                    const emailData = {
                        to: recipients,
                        subject: emailTemplate.notif_temp_title,
                        body: htmlBody,  // Pass the HTML content in the 'body'
                        contentType: 'text/html' // Explicitly set the content type as HTML
                    };

                          // Send the email with HTML content in the body
                          await this.sendEmail(emailData);
                          this.notifySuccess('Email sent successfully to Assigned Advisory.');
                  }
                } catch (error) {
                    console.error('Failed to send email:', error);
                    this.errorFunction(error);
                }
          },
          async sendAssignAdvisorEmail(customerId) {
          try {
                const emailTemplate = await this.fetchEmailTemplate('ASSIGN_ADVISOR');
                if (emailTemplate && emailTemplate.is_active) {
                    let recipients = [];  
                    let emailNotifications = [];

                    if (emailTemplate.notif_assign_advisor) {
                        const user =  await this.getUser(this.current_customer.ssa.id);
												const roleApplication = user.user_role_applications.find(
														app => app.application_code === _gAuth.appCode()
												);

												if (roleApplication && roleApplication.setting_json.email_notifications) {
														emailNotifications = roleApplication.setting_json.email_notifications;
												}

                        const notifications = Array.isArray(emailNotifications) ? emailNotifications : [];

                        // Find the notification with the matching notif_temp_id
                        const existingNotif = notifications.find(
                            (notif) => notif.notif_temp_id === emailTemplate.notif_temp_id
                        );

                        // Check if the notification is disabled and alert the user
                        if (existingNotif && !existingNotif.is_enabled) {
                            this.notifyError('The assigned advisor notification is currently disabled. The user will not receive the email.');
                            return; // Exit the function if notifications are disabled
                        }

                        if (existingNotif && existingNotif.is_enabled) {   
                            // Ensure SSA email is added
                            if (this.current_customer.ssa && this.current_customer.ssa.email) {
                                recipients.push(this.current_customer.ssa.email);  
                            }
                        }

                        if (emailTemplate.notif_temp_receiver) {
                            const defaultRecipients = emailTemplate.notif_temp_receiver
                                .split(',')
                                .map(email => email.trim());
                            recipients = recipients.concat(defaultRecipients);
                        }
                    } else {
                        recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());
                    }

                    const incomeTypeName = await this.getIncomeTypeName(this.current_customer.incomes.main.income_type_id);
                    
                    let baseUrl = window.location.origin;
                    
                    const customerProfileLink = `${baseUrl}/customerProfileDetails/${customerId}?active=overview`;
                    const customerProfileLinkHtml = `<a href="${customerProfileLink}" target="_blank">${customerProfileLink}</a>`;

                    const htmlBody = emailTemplate.notif_temp_message
                        .replace('{customer_name}', this.current_customer.name ?? 'N/A')
                        .replace('{customer_id}', customerId ?? 'N/A')
                        .replace('{channel}', this.current_customer.channel?.name ?? 'N/A')
                        .replace('{created_by}', this.current_customer.created_by_detail?.name ?? 'N/A')
                        .replace('{net_income}', this.current_customer.incomes?.main?.net_income ?? 'N/A')
                        .replace('{income_type}', incomeTypeName ?? 'N/A')
                        .replace('{age}', this.current_customer.age ?? 'N/A')
                        .replace('{customerLink}', customerProfileLinkHtml ?? 'N/A');

                    const emailData = {
                        to: recipients,
                        subject: emailTemplate.notif_temp_title,
                        body: htmlBody,
                        contentType: 'text/html'
                    };

                    await this.sendEmail(emailData);
                    this.notifySuccess('Email sent successfully to Assigned Advisory.');
                }
            } catch (error) {
                console.error('Failed to send email:', error);
                this.errorFunction(error);
            }
          },
           async getIncomeTypeName(income_type_id) {
              this.tables = await this.getLookupTables([
                'income_types',
              ])
              // Check if 'income_types' exists and is an array
              const incomeTypes = this.tables['income_types'];
              
              if (incomeTypes && Array.isArray(incomeTypes)) {
                // Find the income type object that matches the income_type_id
                const incomeType = incomeTypes.find(type => type.income_type_id === income_type_id);
                // Return the name if found, otherwise return a default value
                return incomeType ? incomeType.name : 'Unknown Income Type';
              }

              return 'Unknown Income Type'; // Fallback if income_types is not available
            },
            sendToAdvisory() {
                let text = "Are you sure you want to send this to Fintos Advisory?";
                if (confirm(text) == true) {
                    this.loading = true
                    axios.put(services.customer + 'customer/'+ this.$route.params.customer_id+'/send_to_advisory', null, { headers: getHeader() })
                    .then(async res => {
                        this.notifySuccess('<b>Customer:</b> successfully sent to Fintos Advisory.')
                        this.getCustomer(this.$route.params.customer_id)
                        await this.sendLoanAdvisoryEmail(this.$route.params.customer_id);
                        this.loading = false
                    })
                    .catch(e => {
                        this.errorFunction(e)
                        this.loading = false
                    })
                }
            },
            setMonitoring() {
							this.loading = true

							let is_monitoring = this.current_customer.user_settings?.is_monitoring ? 0 : 1;

							let form = new FormData()
              form.append('is_monitoring', is_monitoring)

							axios.post(services.customer + 'customer/'+ this.$route.params.customer_id+'/user-setting', form, { headers: getHeader() })
							.then(res => {
									this.notifySuccess('<b>Customer:</b> Monitoring has been turn '+(is_monitoring ? 'ON':'OFF'))
									this.getCustomer(this.$route.params.customer_id)
									this.loading = false
							})
							.catch(e => {
									this.errorFunction(e)
									this.loading = false
							})
            },
            assignAgent(){
                this.loading = true
                let formData = {
									se_id : this.selected_se_id,
									ssa_id: this.selected_ssa_id,
                                    sse_id: this.selected_sse_id
								}
                axios.put(services.customer + 'customers/'+ this.$route.params.customer_id+'/assign_agent', formData, { headers: getHeader() })
                .then(res => {
										this.autoSetChatGroup();
                    this.modals.assign_agent = false
                    this.notifySuccess('<b>Customer Agents: '+res.data.data.name+'</b> - Successfully Updated.')
                    this.getCustomer(this.$route.params.customer_id)
                    this.sendAssignAdvisorEmail(this.$route.params.customer_id);
                    this.loading = false
                })
                .catch(e => {
                    this.errorFunction(e)
                    this.loading = false
                })
            },
            close() {
                if(this.$route.params.token)
                {
                    // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                    window.history.back();
                    window.close();
                }
                else
                {
                    this.$router.back();
                }
            },
            toggleAssignModal() {
                if(!_gHlp.checkRoleType(['admin', 'manager', 'director','corporate'])){
                    this.modals.assign_agent = false
                }else{
                    this.modals.assign_agent = !this.modals.assign_agent
                }
            },
						autoSetChatGroup(){
								let user_id = null;
								let type = 'customer';
								let channelIds = _gAuth.activeCorpSettings('lead_reassign_only_channel_ids',[])
								const customer = this.current_customer;
								
								if(!_gHlp.isEmpty(customer)){

									if (customer.se_id != this.selected_se_id && !_gHlp.isEmpty(this.selected_se_id)) {
										user_id = this.selected_se_id;
										let bundle_key = this.getProfileBundleKey('customer', customer);
										let is_add_all_group = true
										this.checkUserGroup(user_id, bundle_key, type, is_add_all_group);
									}
									if (customer.ssa_id != this.selected_ssa_id && !_gHlp.isEmpty(this.selected_ssa_id)) {
										user_id = this.selected_ssa_id;
										let bundle_key = this.getProfileBundleKey('customer', customer);
										let is_add_all_group = true
										this.checkUserGroup(user_id, bundle_key, type, is_add_all_group);
									}
									if (customer.sse_id != this.selected_sse_id && !_gHlp.isEmpty(this.selected_sse_id)) {
										user_id = this.selected_sse_id;
										let bundle_key = this.getProfileBundleKey('customer', customer);
										let is_add_all_group = true
										this.checkUserGroup(user_id, bundle_key, type, is_add_all_group);
									}

								}
						}
        },
        destroyed(){
            this.resetCustomerStore()
            this.resetFintscoreStore()
        },
    }

</script>